import { Buffer } from 'buffer'

const decodeBase64 = (str) => Buffer.from(str, 'base64').toString('utf8')

export default decodeBase64
